import { createSlice, PayloadAction } from '@reduxjs/toolkit';
import { z } from 'zod';
import { calculatorSchema } from './calculatorSchema';
import { isMobileScreenSize } from '@/utils/screen-size';
import {
  CI_LOAN_TO_VALUE,
  CI_MORTGAGE_INTEREST_RATE,
  LOAN_TENURE,
  ReviewingYears,
  YEARLY,
} from '@/constants/commercial-industrial/resale-vs-buc';

export const initialState = {
  formField: {
    reviewingYears: ReviewingYears.THIRD_YEAR,
    resalePurchasePrice: '',
    resaleLoanTenure: LOAN_TENURE.DEFAULT.toString(),
    resaleInterestRate: CI_MORTGAGE_INTEREST_RATE.DEFAULT.toString(),
    resaleLoanToValue: CI_LOAN_TO_VALUE.DEFAULT.toString(),
    resaleIsMonthlyPayment: isMobileScreenSize() ? YEARLY : null,
    resaleSummary: { totalInterest: 0, totalPrincipal: 0 },
    resaleTableDatas: {},
    netResaleAmount: 0,
    bucPurchasePrice: '',
    bucLoanTenure: LOAN_TENURE.DEFAULT.toString(),
    bucInterestRate: CI_MORTGAGE_INTEREST_RATE.DEFAULT.toString(),
    bucLoanToValue: CI_LOAN_TO_VALUE.DEFAULT.toString(),
    bucIsMonthlyPayment: isMobileScreenSize() ? YEARLY : null,
    bucSummary: { totalInterest: 0, totalPrincipal: 0 },
    bucTableDatas: {},
    netBUCAmount: 0,
    rentalFee: '',
    totalRentalFee: 0,
  },
  loading: true,
};

export const commercialIndustrialResaleVsBuc = createSlice({
  name: 'ciResaleVsBuc',
  initialState,
  reducers: {
    updateFormField: (state, action: PayloadAction<z.infer<typeof calculatorSchema>>) => {
      state.formField = action.payload;
    },
  },
  extraReducers: () => {},
});

export const { updateFormField } = commercialIndustrialResaleVsBuc.actions;

export default commercialIndustrialResaleVsBuc.reducer;
